import {
  FETCH_SUBSCRIPTIONS_BEGIN,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE,
  FETCH_DEFAULTHOMEPAGE_BEGIN,
  FETCH_DEFAULTHOMEPAGE_SUCCESS,
  FETCH_DEFAULTHOMEPAGE_FAILURE,
  SAVE_HOMEPAGE_BEGIN,
  SAVE_SUBSCRIPTIONS_BEGIN,
  SAVE_PREFERENCES_SUCCESS,
  SAVE_PREFERENCES_FAILURE,
  SUBSCRIPTIONS_TOGGLE,
  SUBSCRIPTIONS_TOGGLE_ALL,
  HOMEPAGE_SET,
} from '../actions/preferences';

export const initialState = {
  error: null,
  formChanged: false,
  homepage: null,
  isFetching: false,
  subscriptions: [],
  // Per-feature in-flight flags. Wallet UI uses these instead of the shared
  // `isFetching` flag so each section card only re-renders during its own
  // operations — homepage save doesn't flicker the subscriptions card and
  // vice versa. Both flags also drive the visual `disabled` state on inputs
  // mid-save so users see why a click is being ignored.
  homepageBusy: false,
  subscriptionsBusy: false,
};

const preferences = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_DEFAULTHOMEPAGE_BEGIN:
    case SAVE_HOMEPAGE_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
        homepageBusy: true,
      };
    case FETCH_SUBSCRIPTIONS_BEGIN:
    case SAVE_SUBSCRIPTIONS_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
        subscriptionsBusy: true,
      };
    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        error: null,
        formChanged: false,
        isFetching: false,
        subscriptionsBusy: false,
        subscriptions: action.payload,
      };
    case FETCH_DEFAULTHOMEPAGE_SUCCESS:
      return {
        ...state,
        error: null,
        formChanged: false,
        homepage: action.payload,
        isFetching: false,
        homepageBusy: false,
      };
    case SAVE_PREFERENCES_SUCCESS:
      return {
        ...state,
        error: null,
        formChanged: false,
        isFetching: false,
        homepageBusy: false,
        subscriptionsBusy: false,
        isSuccess: true,
      };
    case FETCH_DEFAULTHOMEPAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
        homepageBusy: false,
      };
    // SAVE_PREFERENCES_FAILURE is shared by saveHomepage and saveSubscriptions.
    // Only one save is ever in-flight at a time (handlers guard on isFetching),
    // so unconditionally clearing both busy flags here is always safe — the
    // flag for the section that wasn't saving was already false.
    case SAVE_PREFERENCES_FAILURE:
    case FETCH_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
        homepageBusy: false,
        subscriptionsBusy: false,
      };
    case SUBSCRIPTIONS_TOGGLE: {
      const index = action.payload;
      let { subscriptions } = state;
      const itemToToggle = { ...subscriptions[index] };
      itemToToggle.active = !itemToToggle.active;
      subscriptions = [
        ...subscriptions.slice(0, index),
        itemToToggle,
        ...subscriptions.slice(index + 1),
      ];
      return {
        ...state,
        formChanged: true,
        subscriptions,
      };
    }
    case SUBSCRIPTIONS_TOGGLE_ALL: {
      const allChecked = state.subscriptions.every((sub) => sub.active);
      return {
        ...state,
        formChanged: true,
        subscriptions: state.subscriptions.map((sub) => ({
          ...sub,
          active: !allChecked,
        })),
      };
    }
    case HOMEPAGE_SET:
      // Optimistic update from the wallet UI. Mark homepage busy so the
      // radios disable from the moment of the click through the eventual
      // SAVE_HOMEPAGE_BEGIN/SUCCESS round-trip — prevents a rapid second
      // click from being silently dropped by the isFetching handler guard.
      return {
        ...state,
        homepage: action.payload,
        formChanged: true,
        homepageBusy: true,
      };

    default:
      return state;
  }
};

export default preferences;
